export default __webpack_public_path__ + "static/media/g2g-logo.d4ffba2a.png";